import styled from 'styled-components';

export const StyledProcessingIndicatorContainer = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 12px;
   padding: 20px 16px;
   border-radius: 8px;
   background-color: ${(props) => props.theme.backgroundLighter};
   border: 1px solid ${(props) => props.theme.borderLighter};
`;

StyledProcessingIndicatorContainer.displayName = 'StyledProcessingIndicatorContainer';

export const StyledProcessingMessage = styled.p`
   margin: 0;
   font-size: 13px;
   font-weight: 500;
   color: ${(props) => props.theme.secondary};
   text-align: center;
`;

StyledProcessingMessage.displayName = 'StyledProcessingMessage';
